import { useState, useEffect } from 'react';
import api from '../services/api';
import Sidebar from './Sidebar';
import Anexos from './Anexos';
import AtividadeCustos from './AtividadeCustos';

export default function Pauta({ statusPauta, corPauta, permitirNova = false }) {
  const [atividades, setAtividades] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [tiposAto, setTiposAto] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [colunasList, setColunasList] = useState([]);
  const [mostrarForm, setMostrarForm] = useState(false);
  const [editando, setEditando] = useState(null);
  const [novaObservacao, setNovaObservacao] = useState('');
  const [produtos, setProdutos] = useState([{ tipo_ato_id: '', quantidade: 1 }]);
  const [highlightId, setHighlightId] = useState(null);
  const [filtroNome, setFiltroNome] = useState('');
  const [filtroDetalhe, setFiltroDetalhe] = useState('');
  const [mostrarRetornar, setMostrarRetornar] = useState(false);
  const [retornarPauta, setRetornarPauta] = useState('');
  const [retornarDetalhe, setRetornarDetalhe] = useState('');
  const [mostrarModalBoleto, setMostrarModalBoleto] = useState(false);
  const [vencimentoBoleto, setVencimentoBoleto] = useState('');
  const [emitindoBoleto, setEmitindoBoleto] = useState(false);
  const [resultadoBoleto, setResultadoBoleto] = useState(null);
  const [mostrarCustas, setMostrarCustas] = useState(false);

  const [form, setForm] = useState({
    cliente_id: '', status_pauta: statusPauta, status_detalhe: '',
    junta_comercial: '', preco_final: 0, custo_total: 0,
    protocolo_dbe: '', protocolo_junta: '', protocolo_prefeitura: '',
    data_para_pagamento: null, numero_nfe: '', numero_boleto: '', observacoes: ''
  });

  const usuario = JSON.parse(localStorage.getItem('usuario') || '{}');

  const ordemPautas = ['Em Prospecção', 'Em Andamento', 'Aguardando Registro', 'Aguardando Financeiro', 'Finalizado'];

  const fluxoConcluir = {
    'Em Prospecção': 'Em Andamento',
    'Em Andamento': 'Aguardando Registro',
    'Aguardando Registro': 'Aguardando Financeiro',
    'Aguardando Financeiro': 'Finalizado',
  };

  const corPorPauta = {
    'Em Prospecção': '#7b1fa2',
    'Em Andamento': '#1976d2',
    'Aguardando Registro': '#f57c00',
    'Aguardando Financeiro': '#0097a7',
    'Finalizado': '#388e3c',
  };

  const campoLabels = {
    razao_social: 'Cliente',
    status_detalhe: 'Detalhe',
    preco_final: 'Preço Cliente',
    custo_total: 'Custas',
    protocolo_dbe: 'Protocolo DBE/Viabilidade',
    protocolo_junta: 'Protocolo Junta',
    protocolo_prefeitura: 'Protocolo Prefeitura/Licenciamento',
    data_para_pagamento: 'Data Pagamento',
    numero_nfe: 'NF-e',
    numero_boleto: 'Boleto',
    junta_comercial: 'Local/Junta/Prefeitura',
    status_pagamento_nf: 'Pgto NF',
    status_pagamento_custas: 'Pgto Custas',
    data_abertura: 'Criado em',
    data_alteracao: 'Alterado em',
    produtos_resumo: 'Produtos',
  };

  const feriadosFixos = ['01-01', '21-04', '01-05', '07-09', '12-10', '02-11', '15-11', '25-12'];

  function calcularPascoa(ano) {
    const a = ano % 19, b = Math.floor(ano / 100), c = ano % 100;
    const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const mes = Math.floor((h + l - 7 * m + 114) / 31);
    const dia = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(ano, mes - 1, dia);
  }

  function isFeriadoMovel(data) {
    const ano = data.getFullYear();
    const pascoa = calcularPascoa(ano);
    const carnaval1 = new Date(pascoa); carnaval1.setDate(pascoa.getDate() - 48);
    const carnaval2 = new Date(pascoa); carnaval2.setDate(pascoa.getDate() - 47);
    const sextaSanta = new Date(pascoa); sextaSanta.setDate(pascoa.getDate() - 2);
    return [carnaval1, carnaval2, sextaSanta].some(f => f.toDateString() === data.toDateString());
  }

  function isDiaUtil(data) {
    const diaSemana = data.getDay();
    if (diaSemana === 0 || diaSemana === 6) return false;
    const mmdd = String(data.getMonth() + 1).padStart(2, '0') + '-' + String(data.getDate()).padStart(2, '0');
    if (feriadosFixos.includes(mmdd)) return false;
    if (isFeriadoMovel(data)) return false;
    return true;
  }

  function getMinDatePagamento() {
    let data = new Date();
    data.setDate(data.getDate() + 1);
    while (!isDiaUtil(data)) data.setDate(data.getDate() + 1);
    return data.toISOString().split('T')[0];
  }

  function isDateDisabled(dateStr) {
    if (!dateStr) return false;
    const data = new Date(dateStr + 'T12:00:00');
    return !isDiaUtil(data);
  }

  async function carregarProdutos(atividadeId) {
    const res = await api.get(`/atividades/${atividadeId}/produtos`);
    setProdutos(res.data.length > 0
      ? res.data.map(p => ({ id: p.id, tipo_ato_id: String(p.tipo_ato_id), quantidade: p.quantidade }))
      : [{ tipo_ato_id: '', quantidade: 1 }]
    );
  }

  async function editar(a) {
    setForm({
      cliente_id: a.cliente_id, status_pauta: a.status_pauta,
      status_detalhe: a.status_detalhe || '', junta_comercial: a.junta_comercial || '',
      preco_final: a.preco_final || 0, custo_total: a.custo_total || 0,
      protocolo_dbe: a.protocolo_dbe || '', protocolo_junta: a.protocolo_junta || '',
      protocolo_prefeitura: a.protocolo_prefeitura || '',
      data_para_pagamento: a.data_para_pagamento || null,
      numero_nfe: a.numero_nfe || '', numero_boleto: a.numero_boleto || '',
      observacoes: a.observacoes || ''
    });
    await carregarProdutos(a.id);
    setNovaObservacao('');
    setEditando(a.id);
    setMostrarForm(true);
    setMostrarRetornar(false);
    setRetornarPauta('');
    setRetornarDetalhe('');
    setResultadoBoleto(null);
    setVencimentoBoleto(a.data_para_pagamento || '');
  }

  async function carregar(ordemId = null) {
    const [ativ, cli, tipos] = await Promise.all([
      api.get(`/atividades/?status_pauta=${encodeURIComponent(statusPauta)}`),
      api.get('/clientes/'),
      api.get('/precos/'),
    ]);
    setClientes(cli.data);
    setTiposAto(tipos.data);
    const lista = ativ.data;
    if (ordemId) {
      setAtividades([...lista].sort((a, b) => {
        if (a.id === ordemId) return -1;
        if (b.id === ordemId) return 1;
        return new Date(a.data_alteracao) - new Date(b.data_alteracao);
      }));
    } else {
      setAtividades([...lista].sort((a, b) => new Date(a.data_alteracao) - new Date(b.data_alteracao)));
    }
    return lista;
  }

  async function carregarParametros() {
    const [statusRes, colunasRes] = await Promise.all([
      api.get(`/parametros/status_atividade`).catch(() => ({ data: [] })),
      api.get(`/parametros/${encodeURIComponent('coluna_' + statusPauta)}`).catch(() => ({ data: [] })),
    ]);
    setStatusList(statusRes.data);
    setColunasList(colunasRes.data.map(c => c.valor));
  }

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const highlightParam = params.get('highlight');
    const editParam = params.get('edit');
    if (highlightParam) setHighlightId(parseInt(highlightParam));
    const init = async () => {
      await carregarParametros();
      await carregar(highlightParam ? parseInt(highlightParam) : null);
      if (editParam) {
        const res = await api.get(`/atividades/${editParam}`);
        if (res.data) await editar(res.data);
      }
    };
    init();
  }, []);

  function formatarDataHora() {
    return new Date().toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  }

  function formatarData(dt) {
    if (!dt) return '—';
    return new Date(dt).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  }

  function montarObservacoes() {
    if (!novaObservacao.trim()) return form.observacoes;
    const linha = `[${usuario.nome} - ${formatarDataHora()}] ${novaObservacao.trim()}`;
    return form.observacoes ? `${linha}\n${form.observacoes}` : linha;
  }

  function prepararDados(overrides = {}) {
    const produtosValidos = produtos.filter(p => p.tipo_ato_id);
    return {
      ...form,
      ...overrides,
      data_para_pagamento: form.data_para_pagamento || null,
      observacoes: montarObservacoes(),
      produtos: produtosValidos,
    };
  }

  async function salvar() {
    const produtosValidos = produtos.filter(p => p.tipo_ato_id);
    if (produtosValidos.length === 0) { alert('Adicione pelo menos um produto!'); return; }
    if (form.data_para_pagamento && isDateDisabled(form.data_para_pagamento)) {
      alert('A data de pagamento deve ser um dia útil!'); return;
    }
    if (editando) {
      await api.put(`/atividades/${editando}`, prepararDados());
    } else {
      await api.post('/atividades/', { ...prepararDados(), status_pauta: statusPauta });
    }
    setMostrarForm(false); setEditando(null); setNovaObservacao(''); resetForm(); carregar();
  }

  async function concluir() {
    const proximaPauta = fluxoConcluir[form.status_pauta];
    if (!proximaPauta) return;
    const primeiroDetalhe = statusList.find(s => s.descricao === proximaPauta);
    const confirmar = window.confirm(`⚠️ Atenção!\n\nVocê está concluindo esta atividade na pauta "${form.status_pauta}".\n\nEla será encaminhada para "${proximaPauta}".\n\nDeseja continuar?`);
    if (!confirmar) return;
    const linhaAcao = `[${usuario.nome} - ${formatarDataHora()}] ✅ Concluído — encaminhado para ${proximaPauta}`;
    const obsAtualizada = montarObservacoes();
    const obsFinal = obsAtualizada ? `${linhaAcao}\n${obsAtualizada}` : linhaAcao;
    await api.put(`/atividades/${editando}`, {
      ...prepararDados(),
      status_pauta: proximaPauta,
      status_detalhe: primeiroDetalhe ? primeiroDetalhe.valor : '',
      observacoes: obsFinal,
    });
    setMostrarForm(false); setEditando(null); setNovaObservacao(''); resetForm(); carregar();
  }

  async function confirmarRetornar() {
    if (!retornarPauta) { alert('Selecione a pauta!'); return; }
    if (!retornarDetalhe) { alert('Selecione o detalhe!'); return; }
    const confirmar = window.confirm(`⚠️ Atenção!\n\nVocê está retornando esta atividade para "${retornarPauta} / ${retornarDetalhe}".\n\nDeseja continuar?`);
    if (!confirmar) return;
    const linhaAcao = `[${usuario.nome} - ${formatarDataHora()}] ↩️ Retornado para ${retornarPauta} / ${retornarDetalhe}`;
    const obsAtualizada = montarObservacoes();
    const obsFinal = obsAtualizada ? `${linhaAcao}\n${obsAtualizada}` : linhaAcao;
    await api.put(`/atividades/${editando}`, {
      ...prepararDados(),
      status_pauta: retornarPauta,
      status_detalhe: retornarDetalhe,
      observacoes: obsFinal,
    });
    setMostrarRetornar(false); setRetornarPauta(''); setRetornarDetalhe('');
    setMostrarForm(false); setEditando(null); setNovaObservacao(''); resetForm(); carregar();
  }

  async function emitirBoleto() {
    if (!vencimentoBoleto) { alert('Informe a data de vencimento!'); return; }
    const cliente = clientes.find(c => c.id === form.cliente_id);
    if (!cliente) { alert('Cliente não encontrado!'); return; }
    setEmitindoBoleto(true);
    try {
      const res = await api.post('/cora/emitir', {
        atividade_id: editando,
        valor: form.preco_final,
        vencimento: vencimentoBoleto,
        nome_cliente: cliente.razao_social,
        cpf_cnpj_cliente: cliente.cpf_cnpj,
        email_cliente: cliente.contato_email || '',
      });
      setResultadoBoleto(res.data);
      setForm({ ...form, numero_boleto: res.data.boleto_id });
      carregar();
    } catch (err) {
      alert(`Erro ao emitir boleto: ${err.response?.data?.detail || 'Erro desconhecido'}`);
    } finally {
      setEmitindoBoleto(false);
      setMostrarModalBoleto(false);
    }
  }

  function resetForm() {
    setForm({ cliente_id: '', status_pauta: statusPauta, status_detalhe: '', junta_comercial: '', preco_final: 0, custo_total: 0, protocolo_dbe: '', protocolo_junta: '', protocolo_prefeitura: '', data_para_pagamento: null, numero_nfe: '', numero_boleto: '', observacoes: '' });
    setProdutos([{ tipo_ato_id: '', quantidade: 1 }]);
    setResultadoBoleto(null);
  }

  function nomeCliente(id) {
    const c = clientes.find(c => c.id === id);
    return c ? c.razao_social : '-';
  }

  function adicionarProduto() { setProdutos([...produtos, { tipo_ato_id: '', quantidade: 1 }]); }

  function removerProduto(index) {
    if (produtos.length <= 1) { alert('A atividade deve ter pelo menos um produto!'); return; }
    setProdutos(produtos.filter((_, i) => i !== index));
  }

  function atualizarProduto(index, campo, valor) {
    const novos = [...produtos];
    novos[index] = { ...novos[index], [campo]: valor };
    setProdutos(novos);
  }

  function valorCelula(a, campo) {
    switch(campo) {
      case 'razao_social': return nomeCliente(a.cliente_id);
      case 'status_detalhe': return a.status_detalhe || '—';
      case 'preco_final': return `R$ ${Number(a.preco_final || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`;
      case 'custo_total': return `R$ ${Number(a.custo_total || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`;
      case 'protocolo_dbe': return a.protocolo_dbe || '-';
      case 'protocolo_junta': return a.protocolo_junta || '-';
      case 'protocolo_prefeitura': return a.protocolo_prefeitura || '-';
      case 'data_para_pagamento': return a.data_para_pagamento ? new Date(a.data_para_pagamento + 'T12:00:00').toLocaleDateString('pt-BR') : '-';
      case 'numero_nfe': return a.numero_nfe || '-';
      case 'numero_boleto': return a.numero_boleto || '-';
      case 'junta_comercial': return a.junta_comercial || '-';
      case 'produtos_resumo': return a.produtos_resumo || '-';
      case 'status_pagamento_nf': return <span style={{ color: a.status_pagamento_nf === 'pago' ? '#388e3c' : '#f57c00', fontSize: '12px' }}>{a.status_pagamento_nf}</span>;
      case 'status_pagamento_custas': return <span style={{ color: a.status_pagamento_custas === 'pago' ? '#388e3c' : '#f57c00', fontSize: '12px' }}>{a.status_pagamento_custas}</span>;
      case 'data_abertura': return <span style={{ fontSize: '12px', color: '#888' }}>{formatarData(a.data_abertura)}</span>;
      case 'data_alteracao': return <span style={{ fontSize: '12px', color: '#888' }}>{formatarData(a.data_alteracao)}</span>;
      default: return a[campo] || '-';
    }
  }

  const emProspeccao = form.status_pauta === 'Em Prospecção';
  const detalhesDaPauta = statusList.filter(s => s.descricao === form.status_pauta);
  const detalhesParaFiltro = statusList.filter(s => s.descricao === statusPauta);
  const indiceAtual = ordemPautas.indexOf(form.status_pauta);
  const pautasAnteriores = ordemPautas.slice(0, indiceAtual);
  const detalhesRetornar = statusList.filter(s => s.descricao === retornarPauta);
  const atividadesFiltradas = atividades.filter(a => {
    const nome = nomeCliente(a.cliente_id).toLowerCase();
    const matchNome = filtroNome ? nome.includes(filtroNome.toLowerCase()) : true;
    const matchDetalhe = filtroDetalhe ? a.status_detalhe === filtroDetalhe : true;
    return matchNome && matchDetalhe;
  });

  const inputStyle = { padding: '7px 10px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '13px' };
  const labelStyle = { fontSize: '11px', color: '#555', marginBottom: '3px' };
  const campoStyle = { display: 'flex', flexDirection: 'column', marginBottom: '6px' };
  const isFinanceiro = statusPauta === 'Aguardando Financeiro';

  return (
    <div style={styles.container}>
      <Sidebar />
      <div style={styles.conteudo}>
        <div style={styles.header}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{ ...styles.corIndicador, backgroundColor: corPauta }} />
            <h1 style={styles.titulo}>{statusPauta}</h1>
            <span style={styles.contador}>{atividadesFiltradas.length}</span>
          </div>
          {permitirNova && (
            <button style={styles.botaoNovo} onClick={() => { setMostrarForm(true); setEditando(null); setNovaObservacao(''); resetForm(); }}>
              + Nova Atividade
            </button>
          )}
        </div>

        {mostrarForm && (
          <div style={styles.form}>
            <div style={styles.formHeader}>
              <h3 style={styles.formTitulo}>{editando ? 'Editar Atividade' : 'Nova Atividade'}</h3>
              <div style={{ display: 'flex', gap: '8px' }}>
                {editando && isFinanceiro && (
                  <button style={styles.botaoBoleto} onClick={() => setMostrarModalBoleto(true)}>
                    🏦 Emitir NF/Boleto
                  </button>
                )}
                {editando && fluxoConcluir[form.status_pauta] && (
                  <button style={styles.botaoConcluir} onClick={concluir}>Concluir</button>
                )}
                {editando && pautasAnteriores.length > 0 && (
                  <button style={styles.botaoRetornar} onClick={() => setMostrarRetornar(!mostrarRetornar)}>Retornar</button>
                )}
              </div>
            </div>

            {/* Modal Boleto */}
            {mostrarModalBoleto && (
              <div style={styles.modal}>
                <div style={styles.modalContent}>
                  <h3 style={{ margin: '0 0 1rem', fontSize: '16px', color: '#1a1a2e' }}>🏦 Emitir Boleto</h3>
                  <div style={{ marginBottom: '1rem' }}>
                    <p style={{ fontSize: '13px', color: '#555', marginBottom: '4px' }}>Cliente: <strong>{nomeCliente(form.cliente_id)}</strong></p>
                    <p style={{ fontSize: '13px', color: '#555', marginBottom: '12px' }}>Valor: <strong>R$ {Number(form.preco_final || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</strong></p>
                    <label style={{ fontSize: '12px', color: '#555', display: 'block', marginBottom: '4px' }}>Data de vencimento *</label>
                    <input
                      style={{ ...inputStyle, width: '100%', boxSizing: 'border-box' }}
                      type="date"
                      min={getMinDatePagamento()}
                      value={vencimentoBoleto}
                      onChange={e => setVencimentoBoleto(e.target.value)}
                    />
                  </div>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <button style={styles.botaoBoleto} onClick={emitirBoleto} disabled={emitindoBoleto}>
                      {emitindoBoleto ? 'Emitindo...' : 'Confirmar emissão'}
                    </button>
                    <button style={styles.botaoCancelar} onClick={() => setMostrarModalBoleto(false)}>Cancelar</button>
                  </div>
                </div>
              </div>
            )}

            {/* Resultado boleto */}
 
            {resultadoBoleto && (
              <div style={styles.resultadoBoleto}>
                <p style={{ fontSize: '13px', fontWeight: '600', color: '#388e3c', marginBottom: '8px' }}>✅ Boleto e NF emitidos com sucesso!</p>
                {resultadoBoleto.linha_digitavel && (
                  <p style={{ fontSize: '12px', color: '#555', marginBottom: '4px' }}>
                    Linha digitável: <strong>{resultadoBoleto.linha_digitavel}</strong>
                  </p>
                )}
                {resultadoBoleto.pix_copia_cola && (
                  <p style={{ fontSize: '12px', color: '#555', marginBottom: '4px' }}>
                    PIX Copia e Cola: <strong>{resultadoBoleto.pix_copia_cola}</strong>
                  </p>
                )}
                {resultadoBoleto.nfse_id && (
                  <p style={{ fontSize: '12px', color: '#555', marginBottom: '4px' }}>
                    NFS-e: <strong>{resultadoBoleto.nfse_id}</strong> — {resultadoBoleto.status_nfse}
                  </p>
                )}
                {resultadoBoleto.url_pdf && (
                  <a href={resultadoBoleto.url_pdf} target="_blank" rel="noreferrer" style={{ fontSize: '12px', color: '#1976d2' }}>
                    📄 Abrir PDF do boleto
                  </a>
                )}
              </div>
            )}

            {mostrarRetornar && (
              <div style={styles.retornarBox}>
                <p style={{ fontSize: '13px', fontWeight: '500', marginBottom: '10px', color: '#e53935' }}>↩️ Selecione para onde retornar:</p>
                <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
                  <select style={{ ...inputStyle, flex: 1 }} value={retornarPauta} onChange={e => { setRetornarPauta(e.target.value); setRetornarDetalhe(''); }}>
                    <option value="">Selecione a pauta...</option>
                    {pautasAnteriores.map(p => <option key={p} value={p}>{p}</option>)}
                  </select>
                  <select style={{ ...inputStyle, flex: 1 }} value={retornarDetalhe} onChange={e => setRetornarDetalhe(e.target.value)} disabled={!retornarPauta}>
                    <option value="">Selecione o detalhe...</option>
                    {detalhesRetornar.map(s => <option key={s.id} value={s.valor}>{s.valor}</option>)}
                  </select>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button style={styles.botaoRetornar} onClick={confirmarRetornar}>Confirmar retorno</button>
                  <button style={styles.botaoCancelar} onClick={() => { setMostrarRetornar(false); setRetornarPauta(''); setRetornarDetalhe(''); }}>Cancelar</button>
                </div>
              </div>
            )}

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px' }}>
              <div style={campoStyle}>
                <label style={labelStyle}>Cliente *</label>
                {emProspeccao ? (
                  <select style={inputStyle} value={form.cliente_id} onChange={e => setForm({ ...form, cliente_id: e.target.value })}>
                    <option value="">Selecione...</option>
                    {clientes.map(c => <option key={c.id} value={c.id}>{c.razao_social}</option>)}
                  </select>
                ) : (
                  <input style={{ ...inputStyle, backgroundColor: '#f5f5f5', color: '#666' }} value={nomeCliente(form.cliente_id)} readOnly />
                )}
              </div>
              <div style={campoStyle}>
                <label style={labelStyle}>Pauta</label>
                <div style={{ ...inputStyle, backgroundColor: '#f5f5f5', display: 'flex', alignItems: 'center' }}>
                  <span style={{ ...styles.badgeStatus, backgroundColor: (corPorPauta[form.status_pauta] || '#888') + '22', color: corPorPauta[form.status_pauta] || '#888' }}>
                    {form.status_pauta}
                  </span>
                </div>
              </div>
              <div style={campoStyle}>
                <label style={labelStyle}>Detalhe</label>
                <select style={inputStyle} value={form.status_detalhe} onChange={e => setForm({ ...form, status_detalhe: e.target.value })}>
                  <option value="">—</option>
                  {detalhesDaPauta.map(s => <option key={s.id} value={s.valor}>{s.valor}</option>)}
                </select>
              </div>
              <div style={campoStyle}>
                <label style={labelStyle}>Local/Junta/Prefeitura</label>
                <input style={inputStyle} value={form.junta_comercial} onChange={e => setForm({ ...form, junta_comercial: e.target.value })} placeholder="Ex: JUCESP" />
              </div>
              <div style={campoStyle}>
                <label style={labelStyle}>Preço Cliente (R$)</label>
                <input style={inputStyle} type="number" min="0" step="0.01" value={form.preco_final} onChange={e => setForm({ ...form, preco_final: e.target.value })} />
              </div>
              <div style={campoStyle}>
  		<label style={labelStyle}>
    		Custas (R$)
    		{editando && <AtividadeCustos atividadeId={editando} onUpdate={async () => {
      		const res = await api.get(`/atividades/${editando}`);
      		setForm(f => ({ ...f, custo_total: res.data.custo_total }));
    		}} />}
  		</label>
  		<input
    		style={{ ...inputStyle, backgroundColor: '#f5f5f5', color: '#666' }}
    		type="number"
    		value={form.custo_total}
    		readOnly
  		/>
	      </div>
              <div style={campoStyle}>
                <label style={labelStyle}>Data Pagamento</label>
                <input
                  style={{ ...inputStyle, ...(form.data_para_pagamento && isDateDisabled(form.data_para_pagamento) ? { borderColor: '#e53935' } : {}) }}
                  type="date"
                  min={getMinDatePagamento()}
                  value={form.data_para_pagamento || ''}
                  onChange={e => setForm({ ...form, data_para_pagamento: e.target.value || null })}
                />
                {form.data_para_pagamento && isDateDisabled(form.data_para_pagamento) && (
                  <span style={{ fontSize: '11px', color: '#e53935' }}>Selecione um dia útil</span>
                )}
              </div>
              <div style={campoStyle}>
                <label style={labelStyle}>Nº NF-e</label>
                <input style={inputStyle} value={form.numero_nfe} onChange={e => setForm({ ...form, numero_nfe: e.target.value })} />
              </div>
              <div style={campoStyle}>
                <label style={labelStyle}>Nº Boleto</label>
                <input style={inputStyle} value={form.numero_boleto} onChange={e => setForm({ ...form, numero_boleto: e.target.value })} />
              </div>
              <div style={campoStyle}>
                <label style={labelStyle}>Protocolo DBE/Viabilidade</label>
                <input style={inputStyle} value={form.protocolo_dbe} onChange={e => setForm({ ...form, protocolo_dbe: e.target.value })} />
              </div>
              <div style={campoStyle}>
                <label style={labelStyle}>Protocolo Junta Comercial</label>
                <input style={inputStyle} value={form.protocolo_junta} onChange={e => setForm({ ...form, protocolo_junta: e.target.value })} />
              </div>
              <div style={campoStyle}>
                <label style={labelStyle}>Protocolo Prefeitura/Licenciamento</label>
                <input style={inputStyle} value={form.protocolo_prefeitura} onChange={e => setForm({ ...form, protocolo_prefeitura: e.target.value })} />
              </div>
            </div>

            <div style={{ margin: '1rem 0 0.5rem' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                <label style={{ fontSize: '13px', fontWeight: '500', color: '#1a1a2e' }}>Produtos *</label>
                <button style={styles.botaoAddProduto} onClick={adicionarProduto}>+ Adicionar produto</button>
              </div>
              {produtos.map((p, i) => (
                <div key={i} style={{ display: 'flex', gap: '8px', marginBottom: '8px', alignItems: 'center' }}>
                  <select style={{ ...inputStyle, flex: 1 }} value={p.tipo_ato_id} onChange={e => atualizarProduto(i, 'tipo_ato_id', e.target.value)}>
                    <option value="">Selecione o produto...</option>
                    {tiposAto.map(t => <option key={t.id} value={String(t.id)}>{t.registro}</option>)}
                  </select>
                  <input style={{ ...inputStyle, width: '70px' }} type="number" min="1" value={p.quantidade} onChange={e => atualizarProduto(i, 'quantidade', e.target.value)} />
                  <button style={styles.botaoRemoverProduto} onClick={() => removerProduto(i)}>✕</button>
                </div>
              ))}
            </div>

            {editando && form.observacoes && (
              <div style={{ ...campoStyle, marginBottom: '8px' }}>
                <label style={labelStyle}>Histórico de observações</label>
                <textarea style={{ ...inputStyle, height: '80px', whiteSpace: 'pre-wrap', fontSize: '11px', lineHeight: '1.6', backgroundColor: '#f5f5f5', color: '#666' }} value={form.observacoes} readOnly />
              </div>
            )}
            <div style={campoStyle}>
              <label style={labelStyle}>Nova observação</label>
              <textarea style={{ ...inputStyle, height: '55px' }} placeholder={`Será registrada como [${usuario.nome}]`} value={novaObservacao} onChange={e => setNovaObservacao(e.target.value)} />
            </div>

            {editando && (
              <Anexos clienteId={form.cliente_id} atividadeId={editando} />
            )}

            <div style={styles.formBotoes}>
              <button style={styles.botaoSalvar} onClick={salvar}>Salvar</button>
              <button style={styles.botaoCancelar} onClick={() => { setMostrarForm(false); setEditando(null); setNovaObservacao(''); setMostrarRetornar(false); setResultadoBoleto(null); }}>Cancelar</button>
            </div>
          </div>
        )}

        <div style={{ display: 'flex', gap: '10px', marginBottom: '1rem' }}>
          <input style={{ ...inputStyle, flex: 1 }} placeholder="Pesquisar por nome..." value={filtroNome} onChange={e => setFiltroNome(e.target.value)} />
          {detalhesParaFiltro.length > 0 && (
            <select style={{ ...inputStyle, flex: 1 }} value={filtroDetalhe} onChange={e => setFiltroDetalhe(e.target.value)}>
              <option value="">Todos os detalhes</option>
              {detalhesParaFiltro.map(s => <option key={s.id} value={s.valor}>{s.valor}</option>)}
            </select>
          )}
        </div>

        <table style={styles.tabela}>
          <thead>
            <tr>
              <th style={styles.th}>#</th>
              {colunasList.map(col => (
                <th key={col} style={styles.th}>{campoLabels[col] || col}</th>
              ))}
              <th style={styles.th}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {atividadesFiltradas.map(a => (
              <tr key={a.id} style={{ ...styles.tr, ...(a.id === highlightId ? { backgroundColor: '#fffde7' } : {}) }}>
                <td style={styles.td}>{a.id}</td>
                {colunasList.map(col => (
                  <td key={col} style={styles.td}>{valorCelula(a, col)}</td>
                ))}
                <td style={styles.td}>
                  <button style={styles.botaoEditar} onClick={() => editar(a)}>Editar</button>
                </td>
              </tr>
            ))}
            {atividadesFiltradas.length === 0 && (
              <tr>
                <td colSpan={2 + colunasList.length} style={{ ...styles.td, textAlign: 'center', color: '#aaa', padding: '2rem' }}>
                  Nenhuma atividade encontrada
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const styles = {
  container: { display: 'flex', height: '100vh', overflow: 'hidden', backgroundColor: '#f0f2f5' },
  conteudo: { flex: 1, padding: '2rem', overflowY: 'auto' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' },
  corIndicador: { width: '12px', height: '12px', borderRadius: '50%' },
  titulo: { fontSize: '22px', color: '#1a1a2e', margin: 0 },
  contador: { backgroundColor: '#e8eaf6', color: '#3949ab', padding: '2px 10px', borderRadius: '20px', fontSize: '13px', fontWeight: '500' },
  botaoNovo: { backgroundColor: '#1a1a2e', color: '#fff', border: 'none', padding: '10px 18px', borderRadius: '6px', fontSize: '14px', cursor: 'pointer' },
  form: { backgroundColor: '#fff', padding: '1.25rem', borderRadius: '8px', marginBottom: '1.5rem', border: '1px solid #e0e0e0' },
  formHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' },
  formTitulo: { margin: 0, fontSize: '15px', color: '#1a1a2e' },
  retornarBox: { backgroundColor: '#fff3f3', border: '1px solid #ffcdd2', borderRadius: '8px', padding: '1rem', marginBottom: '1rem' },
  modal: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 },
  modalContent: { backgroundColor: '#fff', padding: '2rem', borderRadius: '12px', width: '400px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' },
  resultadoBoleto: { backgroundColor: '#e8f5e9', border: '1px solid #c8e6c9', borderRadius: '8px', padding: '1rem', marginBottom: '1rem' },
  formBotoes: { display: 'flex', gap: '10px', marginTop: '1rem' },
  botaoSalvar: { backgroundColor: '#1a1a2e', color: '#fff', border: 'none', padding: '9px 20px', borderRadius: '6px', fontSize: '13px', cursor: 'pointer' },
  botaoCancelar: { backgroundColor: 'transparent', color: '#888', border: '1px solid #ddd', padding: '9px 20px', borderRadius: '6px', fontSize: '13px', cursor: 'pointer' },
  botaoConcluir: { backgroundColor: '#388e3c', color: '#fff', border: 'none', padding: '7px 14px', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', fontWeight: '500' },
  botaoRetornar: { backgroundColor: '#e53935', color: '#fff', border: 'none', padding: '7px 14px', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', fontWeight: '500' },
  botaoBoleto: { backgroundColor: '#0097a7', color: '#fff', border: 'none', padding: '7px 14px', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', fontWeight: '500' },
  botaoAddProduto: { backgroundColor: 'transparent', color: '#1976d2', border: '1px solid #1976d2', padding: '4px 10px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer' },
  botaoRemoverProduto: { backgroundColor: 'transparent', color: '#e53935', border: '1px solid #e53935', padding: '4px 8px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer' },
  tabela: { width: '100%', borderCollapse: 'collapse', backgroundColor: '#fff', borderRadius: '8px', overflow: 'hidden' },
  th: { padding: '10px 14px', textAlign: 'left', fontSize: '11px', color: '#888', borderBottom: '1px solid #f0f0f0', fontWeight: '500' },
  tr: { borderBottom: '1px solid #f0f0f0' },
  td: { padding: '10px 14px', fontSize: '13px', color: '#333' },
  badgeStatus: { padding: '3px 8px', borderRadius: '20px', fontSize: '11px', fontWeight: '500' },
  botaoEditar: { backgroundColor: 'transparent', color: '#1a1a2e', border: '1px solid #ddd', padding: '4px 10px', borderRadius: '4px', fontSize: '11px', cursor: 'pointer' },
};